import React from "react";
import { connect } from "react-redux";
import { GlobalState } from "store/configure-store";
import {
  setPayedAmount,
  setPaymentMethod,
} from "store/actions/patient.actions";
import {
  selectDefaultPayedAmount,
  selectPayedAmount,
  selectPaymentMethod,
} from "store/reducers/patient.reducer";
import { PaymentMethodEnum } from "common/enums/PaymentMethodEnum";
import Payment from "./Payment";
import Page from "ui/Page";
import { PV_PAYMENT } from "common/matomo/track-page-view.constants";
import { useTrackPageView } from "common/matomo/track-page-view.hook";

interface StateFromProps {
  defaultPayedAmount: number;
  payedAmount?: number;
  paymentMethod: PaymentMethodEnum;
}

interface DispatchToPropsState {
  setPaymentMethod(paymentMethod: PaymentMethodEnum): void;
  setPayedAmount(amount: number): void;
}

const PaymentContainer = ({
  defaultPayedAmount,
  payedAmount,
  paymentMethod,
  setPaymentMethod,
  setPayedAmount,
}: StateFromProps & DispatchToPropsState) => {
  useTrackPageView(PV_PAYMENT);

  return (
    <Page.Scrollable>
      <Page.Body>
        <Payment
          defaultPayedAmount={defaultPayedAmount}
          payedAmount={payedAmount}
          paymentMethod={paymentMethod}
          setPaymentMethod={setPaymentMethod}
          setPayedAmount={setPayedAmount}
        />
      </Page.Body>
    </Page.Scrollable>
  );
};

const mapStateToProps = (state: GlobalState) => {
  return {
    defaultPayedAmount: selectDefaultPayedAmount(state),
    payedAmount: selectPayedAmount(state),
    paymentMethod: selectPaymentMethod(state),
  };
};

export default connect(mapStateToProps, { setPaymentMethod, setPayedAmount })(
  PaymentContainer
);
